type Listener = () => void;
export const createStore = <S extends Record<string, unknown>>(
  initialState: Partial<S> = {},
) => {
  let state = initialState;
  let listeners: Listener[] = [];

  const getState = () => {
    return state;
  };

  const subscribe = (newListener: Listener) => {
    listeners.push(newListener);

    const unsubscribe = () => {
      listeners = listeners.filter((l) => l !== newListener);
    };

    return unsubscribe;
  };

  const setState = (newState: Partial<S>) => {
    state = {
      ...state,
      ...newState,
    };

    listeners.map((listener) => {
      listener();
    });

    return state;
  };

  return {
    getState,
    setState,
    subscribe,
  };
};
